import { render } from "./extraQuestion.vue?vue&type=template&id=434baf82&scoped=true"
import script from "./extraQuestion.vue?vue&type=script&lang=js"
export * from "./extraQuestion.vue?vue&type=script&lang=js"

import "./extraQuestion.vue?vue&type=style&index=0&id=434baf82&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-434baf82"]])

export default __exports__